import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { SpeakerHigh, SpeakerSlash, Sparkle } from '@phosphor-icons/react';

/**
 * Compact in-line player for the latest Founder Diary track.
 * Pulls /api/founder-diary/latest. Renders nothing if no track exists.
 */
const FounderDiaryPlayer = () => {
  const [track, setTrack] = useState(null);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    axios.get(`${base}/api/founder-diary/latest`)
      .then((res) => setTrack(res.data?.track || null))
      .catch(() => {});
  }, []);

  if (!track?.url) return null;
  const src = `${process.env.REACT_APP_BACKEND_URL || ''}${track.url}`;

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) { a.pause(); setPlaying(false); }
    else { a.play(); setPlaying(true); }
  };

  return (
    <motion.button
      initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      data-testid="founder-diary-player"
      onClick={toggle}
      className="mx-auto mt-4 flex items-center gap-3 rounded-full bg-black/40 backdrop-blur ring-1 ring-bx-cyan/30 px-4 py-2.5 hover:ring-bx-cyan/60 transition"
    >
      <span className={`h-8 w-8 rounded-full bg-bx-cyan/20 grid place-items-center ${playing ? 'animate-pulse' : ''}`}>
        {playing ? <SpeakerHigh size={14} weight="fill" className="text-bx-cyan" /> : <Sparkle size={14} weight="fill" className="text-bx-cyan" />}
      </span>
      <span className="text-xs uppercase tracking-widest text-white/70 font-bold">
        {playing ? 'founder · speaking' : 'a word from the founder'}
      </span>
      <audio ref={audioRef} src={src} preload="none" onEnded={() => setPlaying(false)} />
    </motion.button>
  );
};

export default FounderDiaryPlayer;
